import { render, staticRenderFns } from "./forPc.vue?vue&type=template&id=3ce6117a&scoped=true"
import script from "./forPc.vue?vue&type=script&lang=js"
export * from "./forPc.vue?vue&type=script&lang=js"
import style0 from "./forPc.vue?vue&type=style&index=0&id=3ce6117a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce6117a",
  null
  
)

export default component.exports